var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50529 12.5C8.0347 12.5 9.4321 11.925 10.4935 10.9802L6.25665 6.74337C6.19071 6.67743 6.15364 6.58799 6.15364 6.49474V0.5C3.00538 0.682714 0.5 3.30147 0.5 6.49471C0.5 9.80604 3.19398 12.5 6.50529 12.5Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35422 6.84634L10.9908 10.4829C11.8626 9.50345 12.4192 8.23779 12.5 6.84634H7.35422Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85693 6.14307H12.5C12.324 3.11121 9.88877 0.675962 6.85693 0.5V6.14307Z",
    fill: "#155EEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartBlue);
export default __webpack_public_path__ + "static/media/pie-chart-blue.47e1408eee9ed6db03aa68ae39fa6334.svg";
export { ForwardRef as ReactComponent };